module.exports = __webpack_public_path__ + "assets/img/thumb-Quorn-Pillar-Page-Resource.8c330783.jpg";